module.exports = __webpack_public_path__ + "media/images/upgrade_plan_splash-36f524fe428b771f23caaf37ecd8ff48.svg";